import {
    INVOICE_NOTIFIER_ERROR_INVALID_FILE,
    INVOICE_NOTIFIER_ERROR_INVALID_FILE_TYPE,
    INVOICE_NOTIFIER_ERROR_INVALID_FILE_CSV_HEADER,
    INVOICE_NOTIFIER_ERROR_INVALID_WINNING_INVOICE_RECORD,
    INVOICE_NOTIFIER_ERROR_CONFLICT
} from 'constants/invoice-notifier';

const invoiceWinnerNotifier = {
    'document_title': 'Winning Invoice Notification',
    'import_info': 'Please import the winning invoice CSV file to start the process.',
    'import_invoice_file': 'Import Winning Invoice CSV File',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_INVALID_FILE }`]: 'Invalid file, please try again.',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_INVALID_FILE_TYPE }`]: 'Invalid file format, please upload csv file.',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_INVALID_FILE_CSV_HEADER }`]: 'Invalid CSV header, please ensure the csv headers matches the original Ezpay header format.',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_INVALID_WINNING_INVOICE_RECORD }`]: 'Invalid winning invoice record. Please make sure all invoice numbers exist in the file, or check whether the following invoice content is correct: %{invoice_number}',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_CONFLICT }`]: 'The winning invoice file is already processing.',
    'import_success': 'We are sending your winning invoice file now. You\'ll get a sending result email once completed.',
};

export default invoiceWinnerNotifier;
